module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"policy":"the privacy policy","read":"I have read"}}')
  delete Component.options._Ctor
}
